<nz-modal
  [(nzVisible)]="visibleValue"
  (nzVisibleChange)="toggleModal($event)"
  [nzWidth]="708"
  [nzFooter]="null"
  (nzOnCancel)="toggleModal(false)"
  nzCentered
  nzWrapClassName="ai-analysis-modal"
>
  <ng-container *nzModalContent>
    <div class="ai-analysis-modal-wrapper">
      @if(currentQuestion()) {
        <div class="response-container">
          <div class="chat-header">{{ 'aiAnalysis.header' | translate }}</div>
          <div class="chat-disclaimer">{{ 'aiAnalysis.disclaimer' | translate }}</div>
          <div class="chat-wrapper">
            <div class="question-asked">
              {{ ('aiAnalysis.availableQuestionsCodes.' + openSource() + '.' + currentQuestion()) | translate }}
            </div>
            <div
              class="question-response"
              [class.question-response--center]="!isButtonLayoutActive()"
            >
              <div class="response-icon-container">
                <svg-icon src="assets/icons/ai-icon.svg" [svgStyle]="{ 'width.px':16, 'height.px':16 }"></svg-icon>
              </div>
              @let lastResponse = latestResponse();
                <div class="response-content">
                  @if(!lastResponse || lastResponse.type === 'response.started') {
                    <div class="response-state">
                      {{  ('aiAnalysis.updateStages.started') | translate }}
                    </div>
                  } @else if (lastResponse.type === 'response.update') {
                    @if(lastResponse.stage!) {
                      <div class="response-state">
                        {{  ('aiAnalysis.updateStages.' + lastResponse.stage) | translate }}
                      </div>
                    } @else {
                      <div class="response-state">
                        {{  ('aiAnalysis.updateStages.started') | translate }}
                      </div>
                    }
                  } @else if (lastResponse.type === 'response.failed') {
                    <div class="response-state">
                      {{ 'aiAnalysis.generationError' | translate }}
                    </div>
                    @if(lastResponse.retryable) {
                      <div class="retry-button-wrapper">
                        <liberro-button
                          (click)="callApi()"
                          [label]="'aiAnalysis.tryAgain' | translate"
                          customHeight="32px"
                          customMinWidth="121px"
                        ></liberro-button>
                      </div>
                    }
                  } @else if (showText()) {
                    <div class="response-state">
                      {{ 'aiAnalysis.aiResponse' | translate }}
                    </div>
                  } @else if (apiCallErrored()) {
                    <div class="response-state">
                      {{ 'aiAnalysis.generationError' | translate }}
                    </div>
                  }
                    @if(displayStopButton()) {
                      <liberro-button
                        (click)="stopGeneration()"
                        [label]="'aiAnalysis.stopGeneration' | translate"
                        customHeight="32px"
                        customMinWidth="121px"
                      ></liberro-button>
                    }
                </div>
                <div class="response-content response-content--column">
                  @if (showText()) {
                    <div [innerHTML]="showText()?.replace(/\\n/g, '<br>')" liberroRevealHtml class="reveal-text generated-response"></div>
                    <div class="swiper-wrapper">
                      <swiper-container
                        init="false"
                        #swiperEl
                        slides-per-view="1"
                        free-mode="false"
                        slides-offset-before="0"
                        slides-offset-after="0"
                        space-between="30"
                        centered-slides="true"
                        [pagination]="{
                          clickable: true,
                          type: 'bullets',
                          el: bullets,
                        }"
                        [navigation]="{
                          enabled: regionalOrientationsWeightsChartData && categoryWeightsChartData,
                          nextEl: nextBtn,
                          prevEl: prevBtn,
                          addIcons: false,
                        }"
                      >
                        @if(regionalOrientationsWeightsChartData) {
                        <swiper-slide>
                          <div class="chart-wrapper">

                            <liberro-pie-chart [chartData]="regionalOrientationsWeightsChartData"></liberro-pie-chart>
                          </div>
                        </swiper-slide>
                        }
                        @if(categoryWeightsChartData) {
                        <swiper-slide>
                          <div class="chart-wrapper">
                            <liberro-pie-chart [chartData]="categoryWeightsChartData"></liberro-pie-chart>
                          </div>
                        </swiper-slide>
                        }
                      </swiper-container>
                      <div class="swiper-navigation">
                        <div class="swiper-button-prev-custom" tabindex="0" #prevBtn>
                          <svg-icon class="swiper-pagination-arrow-icon" [src]="'assets/icons/arrow-link.svg'"></svg-icon>
                        </div>
                        <div class="thematic-swiper-bullets" tabindex="1" #bullets></div>
                        <div class="swiper-button-next-custom" tabindex="2" #nextBtn>
                          <svg-icon class="swiper-pagination-arrow-icon" [src]="'assets/icons/arrow-link.svg'"></svg-icon>
                        </div>
                      </div>
                    </div>
                  }
                </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="icon-header-container">
          <div class="default-frame">
            <svg-icon src="assets/icons/ai-icon.svg" [svgStyle]="{ 'width.px':35, 'height.px':35 }"></svg-icon>
            <div class="default-header">{{ 'aiAnalysis.header' | translate }}</div>
            <div class="default-subheader">
              {{ ('aiAnalysis.subHeader.' + openSource()) | translate }}
            </div>
          </div>
        </div>
        <div class="available-questions-header">
          {{ 'aiAnalysis.availableQuestionsHeader' | translate }}
        </div>
      }
      <!-- todo - v2 - add subquestions here -->
      @if(!currentQuestion()) {
        <div class="available-questions">
          @for(question of availableQuestionsCodes; track $index) {
            <div class="question-row" (click)="askQuestion(question)">
              <svg-icon src="assets/icons/ai-icon.svg" [svgStyle]="{ 'width.px':16, 'height.px':16 }"></svg-icon>
              {{ ('aiAnalysis.availableQuestionsCodes.' + openSource() + '.' + question) | translate }}
            </div>
          }
        </div>
      }
    </div>
  </ng-container>
</nz-modal>
